import React from "react";
import { AddFlex, CustomText } from "../reusableStyles";
import InstagramAccountSwitcher from "../Integrations/Instagram/InstagramAccountSwitcher";
import { callNonStoreApi } from "../NonStoreApis";
import { AddInstagramDetailForSingleLiecense } from "../Api/ApiEndPoints";
import { enqueueSnackbar } from "notistack";

function SingleLiecenseInstagramAccount({ setViewType }) {
  const handleSelectInstaAccountForSingleLiecense = async (accountDetails) => {
    try {
      // do api to add instagram details
      const response = await callNonStoreApi(
        AddInstagramDetailForSingleLiecense,
        {
          instaAccount: accountDetails,
        }
      );
      enqueueSnackbar("Successfully added the instagram account", {
        variant: "success",
      });
      setViewType(2);
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Something went wrong", {
        variant: "error",
      });
    }
  };
  return (
    <AddFlex gap="10px" flexDirection="column">
      <CustomText color="black" fontWeight="500">
        Select the instagram account to link with your Liecense
      </CustomText>
      <InstagramAccountSwitcher
        onClick={handleSelectInstaAccountForSingleLiecense}
        style={{ position: "absolute", zIndex: 11111, top: "100%", left: "0" }}
      />
    </AddFlex>
  );
}

export default SingleLiecenseInstagramAccount;
